import React, { useEffect, useState, useCallback }  from 'react';
import { Row, Col } from 'react-bootstrap';
import { motion } from "framer-motion";

import SkeletonLoader from "../../../../../ui/SkeletonLoader";

import { useScanInfoContext } from "../../../../../../pages/ScanInfo/ScanInfoContext";

import { useSelector, useDispatch } from 'react-redux';
import { getSSLExpiryStats } from "../../../../../../store/actions/thirdPartyRiskAction";
import { formatNumber } from "../../../../../../utils/util";

import { dashboardSSLExpiry30DaysIcon, dashboardSSLExpiry60DaysIcon, dashboardSSLExpiry90DaysIcon } from "../../../../../../utils/icons";

const SSLExpiry = () => {

    const sslExpiryStatsResponse = useSelector((state) => state.thirdPartyRisk.sslExpiryStats)
    
    const {
        domainId,
        scanId,
        organizationId,
        triggerStatsFetch,
        setTriggerStatsFetch,
    } = useScanInfoContext();

    const dispatch = useDispatch();

    const [sslExpiryStatsLoading, setSSLExpiryStatsLoading] = useState(false);
    const [sslExpiryStatsStats, setSSLExpiryStatsStats] = useState(null);

    const fetchSSLExpiryStats = useCallback(()=>{
        setSSLExpiryStatsLoading(true)
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`;
        dispatch(getSSLExpiryStats(params))
    },[dispatch, organizationId, domainId, scanId])

    useEffect(()=>{
        if (triggerStatsFetch) {
            fetchSSLExpiryStats();
            setTriggerStatsFetch(false);
        }
    },[triggerStatsFetch, setTriggerStatsFetch, fetchSSLExpiryStats])

    useEffect(()=>{
        if(sslExpiryStatsResponse !== null) {
            setSSLExpiryStatsLoading(false);
            setSSLExpiryStatsStats(sslExpiryStatsResponse)
        }
    },[sslExpiryStatsResponse])

    return (
        <div className="bg-white-with-shadow p-4 h-100">
            {
                sslExpiryStatsLoading ?
                <SkeletonLoader type={"line"} count={7} currentPage={"digitalfootprint"} />
                :
                <motion.div
                    className="h-100"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4 }}
                >
                    <div className="d-flex justify-content-between mb-2 dashboard-box-container">
                        <p className="heading font-bold">SSL Expiry (In Days)</p>
                    </div>
                    <div className="box-orange expire align-items-center p-3 mt-4">
                        <Row className="justify-content-between align-items-center">
                            <Col lg={6} className="text-end">
                                <div className="cert d-flex gap-3">
                                    <p className="mb-0">Expired Certificates</p>
                                </div>
                            </Col>
                            <Col lg={6} className="text-start">
                                <div className="d-flex justify-content-end">
                                    <p className='text-expire mt-2'>{formatNumber(sslExpiryStatsStats?.stats?.expired)}</p>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="box-high expire align-items-center p-3 mt-2">
                        <Row className="justify-content-between align-items-center">
                            <Col lg={6} className="text-end">
                                <div className="cert d-flex gap-3">
                                    <p className="mb-0">&lt;30 Days</p>
                                </div>
                            </Col>
                            <Col lg={6} className="text-start">
                                <div className="d-flex align-items-center justify-content-end gap-2">
                                    <p className='text-expire'>{formatNumber(sslExpiryStatsStats?.stats?.expire_in_30_day)}</p>
                                    <span>{dashboardSSLExpiry30DaysIcon()}</span>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="box-medium expire align-items-center p-3 mt-2">
                        <Row className="justify-content-between align-items-center">
                            <Col lg={6} className="text-end">
                                <div className="cert d-flex gap-3">
                                    <p className="mb-0">&lt;60 Days</p>
                                </div>
                            </Col>
                            <Col lg={6} className="text-start">
                                <div className="d-flex align-items-center justify-content-end gap-2">
                                    <p className='text-expire'>{formatNumber(sslExpiryStatsStats?.stats?.expire_in_60_day)}</p>
                                    <span>{dashboardSSLExpiry60DaysIcon()}</span>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="box-low expire align-items-center p-3 mt-2">
                        <Row className="justify-content-between align-items-center">
                            <Col lg={6} className="text-end">
                                <div className="cert d-flex gap-3">
                                    <p className="mb-0">&lt;90 Days</p>
                                </div>
                            </Col>
                            <Col lg={6} className="text-start">
                                <div className="d-flex align-items-center justify-content-end gap-2">
                                    <p className='text-expire'>{formatNumber(sslExpiryStatsStats?.stats?.expire_in_90_day)}</p>
                                    <span>{dashboardSSLExpiry90DaysIcon()}</span>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </motion.div>
            }
        </div>
    )
}

export default SSLExpiry;